import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex justify-between items-center mb-6" }
const _hoisted_3 = { class: "relative w-1/3" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center items-center py-12"
}
const _hoisted_5 = {
  key: 1,
  class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6"
}
const _hoisted_6 = { class: "block sm:inline" }
const _hoisted_7 = {
  key: 2,
  class: "bg-gray-100 border border-gray-300 text-gray-700 px-4 py-8 rounded-md text-center"
}
const _hoisted_8 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = {
  key: 3,
  class: "bg-white shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
}
const _hoisted_11 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_12 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_14 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_15 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_16 = { class: "text-sm text-gray-900" }
const _hoisted_17 = { class: "px-6 py-4" }
const _hoisted_18 = { class: "text-sm text-gray-900 max-w-md" }
const _hoisted_19 = { class: "list-disc pl-5 space-y-1" }
const _hoisted_20 = { class: "px-6 py-4 whitespace-nowrap text-center text-sm font-medium" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 4,
  class: "fixed inset-0 z-50 flex items-center justify-center"
}
const _hoisted_24 = { class: "bg-white rounded-lg shadow-xl w-full max-w-2xl z-10 relative" }
const _hoisted_25 = { class: "px-6 py-4 border-b border-gray-200" }
const _hoisted_26 = { class: "text-lg font-medium text-gray-900" }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = { class: "mb-4" }
const _hoisted_30 = { class: "space-y-2" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
}
const _hoisted_34 = { class: "block sm:inline" }
const _hoisted_35 = { class: "flex justify-end space-x-3 mt-6" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 5,
  class: "fixed inset-0 z-50 flex items-center justify-center"
}
const _hoisted_40 = { class: "bg-white rounded-lg shadow-xl w-full max-w-md z-10 relative" }
const _hoisted_41 = { class: "px-6 py-4" }
const _hoisted_42 = { class: "mt-2 font-medium text-gray-900" }
const _hoisted_43 = { class: "px-6 py-4 bg-gray-50 flex justify-end space-x-3" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
          placeholder: "Search...",
          class: "w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
        }, null, 544), [
          [_vModelText, _ctx.searchTerm]
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" }, [
          _createElementVNode("svg", {
            class: "h-5 w-5 text-gray-400",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
              "clip-rule": "evenodd"
            })
          ])
        ], -1))
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openEntryModal())),
        class: "px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      }, " New Entry ")
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[15] || (_cache[15] = [
          _createElementVNode("svg", {
            class: "animate-spin h-8 w-8 text-indigo-600",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
          ], -1)
        ])))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[16] || (_cache[16] = _createElementVNode("strong", { class: "font-bold" }, "Error!", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.error.message), 1),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fetchEntries && _ctx.fetchEntries(...args))),
              class: "mt-2 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            }, " Try Again ")
          ]))
        : (_ctx.filteredEntries.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[18] || (_cache[18] = _createElementVNode("svg", {
                class: "mx-auto h-12 w-12 text-gray-400",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                })
              ], -1)),
              _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "mt-2 text-sm font-medium text-gray-900" }, "No entries found", -1)),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.searchTerm ? 'No entries match your search criteria.' : 'Start by adding a new entry.'), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openEntryModal())),
                  class: "inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                }, _cache[17] || (_cache[17] = [
                  _createElementVNode("svg", {
                    class: "-ml-1 mr-2 h-5 w-5",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
                      "clip-rule": "evenodd"
                    })
                  ], -1),
                  _createTextVNode(" New Entry ")
                ]))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _cache[22] || (_cache[22] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, " Topic "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, " Subtopic "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, " Description "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, " Actions ")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEntries, (entry) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: entry.id,
                      class: "hover:bg-gray-50"
                    }, [
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(entry.topic), 1)
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(entry.subtopic), 1)
                      ]),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("ul", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parseBulletpoints(entry.description), (point, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(point), 1))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.openEntryModal(entry)),
                          class: "text-indigo-600 hover:text-indigo-900 mr-4",
                          title: "Edit"
                        }, _cache[20] || (_cache[20] = [
                          _createElementVNode("svg", {
                            class: "h-5 w-5",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", { d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" })
                          ], -1)
                        ]), 8, _hoisted_21),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.confirmDelete(entry)),
                          class: "text-red-600 hover:text-red-900",
                          title: "Delete"
                        }, _cache[21] || (_cache[21] = [
                          _createElementVNode("svg", {
                            class: "h-5 w-5",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                              "clip-rule": "evenodd"
                            })
                          ], -1)
                        ]), 8, _hoisted_22)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])),
    (_ctx.showEntryModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black bg-opacity-50",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeEntryModal && _ctx.closeEntryModal(...args)))
          }),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.currentEntry.id ? 'Edit Entry' : 'New Entry'), 1)
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveEntry && _ctx.saveEntry(...args)), ["prevent"])),
              class: "px-6 py-4"
            }, [
              _createElementVNode("div", _hoisted_27, [
                _cache[23] || (_cache[23] = _createElementVNode("label", {
                  for: "topic",
                  class: "block text-sm font-medium text-gray-700 mb-1"
                }, "Topic", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "topic",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentEntry.topic) = $event)),
                  type: "text",
                  required: "",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                }, null, 512), [
                  [_vModelText, _ctx.currentEntry.topic]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[24] || (_cache[24] = _createElementVNode("label", {
                  for: "subtopic",
                  class: "block text-sm font-medium text-gray-700 mb-1"
                }, "Subtopic", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "subtopic",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentEntry.subtopic) = $event)),
                  type: "text",
                  required: "",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                }, null, 512), [
                  [_vModelText, _ctx.currentEntry.subtopic]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Description (Bulletpoints)", -1)),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulletpoints, (point, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex items-center"
                    }, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "mr-2 text-gray-500" }, "-", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((_ctx.bulletpoints[index]) = $event),
                        type: "text",
                        class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500",
                        placeholder: "Bulletpoint"
                      }, null, 8, _hoisted_31), [
                        [_vModelText, _ctx.bulletpoints[index]]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeBulletpoint(index)),
                        class: "ml-2 text-red-600 hover:text-red-900"
                      }, _cache[25] || (_cache[25] = [
                        _createElementVNode("svg", {
                          class: "h-5 w-5",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 20 20",
                          fill: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                            "clip-rule": "evenodd"
                          })
                        ], -1)
                      ]), 8, _hoisted_32)
                    ]))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addBulletpoint && _ctx.addBulletpoint(...args))),
                    class: "mt-2 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  }, _cache[27] || (_cache[27] = [
                    _createElementVNode("svg", {
                      class: "-ml-0.5 mr-2 h-4 w-4",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
                        "clip-rule": "evenodd"
                      })
                    ], -1),
                    _createTextVNode(" Add Bulletpoint ")
                  ]))
                ])
              ]),
              (_ctx.formError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _cache[29] || (_cache[29] = _createElementVNode("strong", { class: "font-bold" }, "Error!", -1)),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.formError), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeEntryModal && _ctx.closeEntryModal(...args))),
                  class: "px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                }, " Cancel "),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: _ctx.formSubmitting,
                  class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                }, [
                  (_ctx.formSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Saving..."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_38, "Save"))
                ], 8, _hoisted_36)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black bg-opacity-50",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_40, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "px-6 py-4 border-b border-gray-200" }, [
              _createElementVNode("h3", { class: "text-lg font-medium text-gray-900" }, "Delete Entry")
            ], -1)),
            _createElementVNode("div", _hoisted_41, [
              _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-gray-700" }, " Are you sure you want to delete this entry? ", -1)),
              _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.entryToDelete?.topic) + " - " + _toDisplayString(_ctx.entryToDelete?.subtopic), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.deleteEntry && _ctx.deleteEntry(...args))),
                disabled: _ctx.deleteSubmitting,
                class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
              }, [
                (_ctx.deleteSubmitting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Deleting..."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_46, "Delete"))
              ], 8, _hoisted_44)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}